export class Schedules {
    static readonly GET_AUTORUN_DETAILS_BY_REPORT_ID =
        '/api/Schedules/httpGet_GetAutorunDetailsByReportID';
    static readonly GET_EXCEL_REPORT_FILE_RESPONSE_MODEL =
        '/api/Schedules/httpPost_GetExcelReportFileResponseModel';
    static readonly SET_AUTORUN_DETAILS_BY_REPORT_ID =
        '/api/Schedules/httpPost_SetAutoRunDetailsByReportID';
}

export default Schedules;
